export default __webpack_public_path__ + "static/TacosWithChipsAndGuac-34ef261e0c101ba77d8813779219e67b.jpeg";